import { render, staticRenderFns } from "./GroupOfAccreditationsList.vue?vue&type=template&id=60204a36"
import script from "./GroupOfAccreditationsList.vue?vue&type=script&lang=js"
export * from "./GroupOfAccreditationsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports